import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseModal, Grid } from '../../shared'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { Employee } from './org-chart.component'

@Component({
    templateUrl: './training-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjGridModule, AutoSizeDirective, WjGridFilterModule],
})
export class TrainingModalComponent extends BaseModal implements OnInit {
    employee!: Employee
    data: any
    trainGrid: Grid<any>
    certGrid: Grid<any>

    constructor() {
        super()

        this.trainGrid = new Grid<any>(this.services).wrapColumnHeaders().doInitialSelection(false)
        this.certGrid = new Grid<any>(this.services).wrapColumnHeaders().doInitialSelection(false)
    }

    ngOnInit(): void {
        this.trainGrid.items = this.employee.trainingDtos
        this.certGrid.items = this.employee.skillDtos
    }
}
